/* ==========================================================================
   Cairnspring Mills — Recipe template interactions
   - Video popup (YouTube / Vimeo / direct MP4)
   - Share (native OS share sheet, with an email/text/social fallback menu)
   - Print
   - Cook Mode (Screen Wake Lock + inline per-step ingredients on mobile)
   Vanilla JS, no dependencies. Safe to load with `defer`.
   ========================================================================== */
(function () {
  function buildEmbed(url) {
    if (!url) return "";
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
    if (yt) {
      return '<iframe src="https://www.youtube.com/embed/' + yt[1] +
        '?autoplay=1&rel=0" title="Recipe video" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>';
    }
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) {
      return '<iframe src="https://player.vimeo.com/video/' + vm[1] +
        '?autoplay=1" title="Recipe video" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    }
    return '<video controls autoplay playsinline src="' + url + '"></video>';
  }

  function initShareFallback(btn) {
    var url = window.location.href;
    var title = document.title;
    var pop = document.createElement("div");
    pop.className = "recipe-share-pop";
    pop.hidden = true;
    pop.innerHTML =
      '<button type="button" data-share-copy>Copy link</button>' +
      '<a href="mailto:?subject=' + encodeURIComponent(title) +
        "&body=" + encodeURIComponent(url) + '">Email</a>' +
      '<a href="sms:?&body=' + encodeURIComponent(title + " " + url) + '">Text message</a>' +
      '<a target="_blank" rel="noopener" href="https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) + '">Facebook</a>' +
      '<a target="_blank" rel="noopener" href="https://twitter.com/intent/tweet?url=' +
        encodeURIComponent(url) + "&text=" + encodeURIComponent(title) + '">X</a>' +
      '<a target="_blank" rel="noopener" href="https://pinterest.com/pin/create/button/?url=' +
        encodeURIComponent(url) + "&description=" + encodeURIComponent(title) + '">Pinterest</a>';
    btn.parentNode.appendChild(pop);

    var copy = pop.querySelector("[data-share-copy]");
    copy.addEventListener("click", function () {
      if (navigator.clipboard) navigator.clipboard.writeText(url);
      copy.textContent = "Copied!";
      setTimeout(function () { copy.textContent = "Copy link"; }, 1500);
    });

    document.addEventListener("click", function (e) {
      if (!pop.hidden && !pop.contains(e.target) && e.target !== btn) pop.hidden = true;
    });
    return pop;
  }

  function initRecipe(root) {
    if (!root || root.dataset.recipeInit) return;
    root.dataset.recipeInit = "true";

    /* ---- Cook Mode: wake lock + mobile inline ingredients ---- */
    var cookToggle = root.querySelector("[data-cook-mode]");
    var wakeLock = null;

    function requestWake() {
      if (!("wakeLock" in navigator)) return;
      navigator.wakeLock.request("screen").then(function (lock) {
        wakeLock = lock;
        lock.addEventListener("release", function () { wakeLock = null; });
      }).catch(function () {});
    }
    function releaseWake() {
      if (wakeLock) { wakeLock.release().catch(function () {}); wakeLock = null; }
    }

    if (cookToggle) {
      cookToggle.addEventListener("change", function () {
        if (cookToggle.checked) {
          root.classList.add("is-cook-mode");
          requestWake();
        } else {
          root.classList.remove("is-cook-mode");
          releaseWake();
        }
      });
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "visible" && cookToggle.checked && !wakeLock) {
          requestWake();
        }
      });
    }

    /* ---- Print ---- */
    var printBtn = root.querySelector("[data-recipe-print]");
    if (printBtn) printBtn.addEventListener("click", function () {
      var pdf = printBtn.getAttribute("data-print-pdf");
      if (pdf) {
        // A designed per-recipe PDF exists — open it in a new tab to view/print/save.
        window.open(pdf, "_blank", "noopener");
      } else {
        window.print();
      }
    });

    /* ---- Share ---- */
    var shareBtn = root.querySelector("[data-recipe-share]");
    if (shareBtn) {
      var pop = null;
      shareBtn.addEventListener("click", function () {
        var data = { title: document.title, url: window.location.href };
        if (navigator.share) {
          navigator.share(data).catch(function () {});
          return;
        }
        if (!pop) pop = initShareFallback(shareBtn);
        pop.hidden = !pop.hidden;
      });
    }

    /* ---- Video modal ---- */
    var modal = root.querySelector("[data-recipe-modal]");
    var playBtn = root.querySelector("[data-recipe-play]");
    var mount = root.querySelector("[data-recipe-video-mount]");
    var closeBtn = root.querySelector("[data-recipe-modal-close]");

    function openModal() {
      if (!modal || !mount) return;
      mount.innerHTML = buildEmbed(mount.getAttribute("data-video-url"));
      if (typeof modal.showModal === "function") modal.showModal();
      else modal.setAttribute("open", "");
    }
    function closeModal() {
      if (!modal) return;
      if (typeof modal.close === "function") modal.close();
      else modal.removeAttribute("open");
      mount.innerHTML = ""; // stop playback
    }
    if (playBtn) playBtn.addEventListener("click", openModal);
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (modal) {
      modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });
      modal.addEventListener("close", function () { mount.innerHTML = ""; });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-recipe]").forEach(initRecipe);
  }

  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", function () { initAll(); });

  // Re-init inside the theme editor when the section is added/re-rendered.
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();